import React, { useState, useEffect } from 'react';
import "./Nav.scss";
import MenuIcon from "@mui/icons-material/Menu";
import SearchIcon from "@mui/icons-material/Search";
import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { Link} from "react-router-dom";
import { useAuth } from "../context/AuthContext";

function Nav() {
    const [navBlack, setNavBlack] = useState(false);
    const [toggleMenu, setToggleMenu] = useState(false);
    const { user } = useAuth();

    const transitionNav = () => {
        window.scrollY > 100 ? setNavBlack(true) : setNavBlack(false);
    };

    useEffect(() => {
        document.addEventListener("scroll", transitionNav);
        // Cleanup the event listener on component unmount
        return () => {
            document.removeEventListener("scroll", transitionNav);
        };
    }, []);

    const handleClick = () => {
        setToggleMenu(!toggleMenu);
    };
    //console.log(user);
    //user.nom

    return (
        <div className={`nav ${
            navBlack || toggleMenu ? "nav--black" : "nav--transparent"
            } ${toggleMenu && "show"}`}>
            <button className='nav__burger' onClick={handleClick}><MenuIcon /></button>
            <img src={`${process.env.PUBLIC_URL}/images/mobing.png`} className='nav__logo' alt='mon-image' />
            <nav className='nav__links'>
                <a href='#' className='nav__link'>Accueil</a>
                <a href='#' className='nav__link'>Series</a>
                <a href='#' className='nav__link'>Films</a>
            </nav>
            <div className='nav__actions'>
                <a href='#' className='nav__action'><SearchIcon /></a>
                <a href='#' className='nav__action'>DIRECT</a>
                <a href='#' className='nav__action'><CardGiftcardIcon /></a>
                <a href='#' className='nav__action'><NotificationsIcon /></a>
                
                <Link to="/login"  className='nav__action'> 
                    <img src={`${process.env.PUBLIC_URL}/images/avatar.png`} className='nav__avatar' alt='avatar' />
                </Link>
            </div>
        </div>
    );
}

export default Nav;
